import { socket } from "@/feed.socket";
import { defineStore, storeToRefs } from "pinia";
import { useBetslipStore } from "./betslip";
import { useAuthStore } from "./auth";
import { useFixturesStore } from "./fixtures";

export const useLiveStore = defineStore('live', {
    state: () => ({}),
    getters: {},
    actions: {
        parseOddsMessage(message) {
            const parts = message.split("|");
            return {
                i: parts[0], 
                n: parts[1], //odd name
                s: Number(parts[2]) || 0, //odd sort
                c: Number(parts[3]) || 0, //odd column
                v: parseFloat(parts[4]) || 0, //selection v
                p: parseFloat(parts[5]) || 0, //selection p
                mv: parts[6] || "", //odd mv
                mi: parts[7] || "", //market id
                fi: parts[8] || "", // event it
                st: parts[9] || "", //selection status,
                mui: parts[10] 
            };
        },
        bindSocketEvents() {
            socket.on('odds:live', (data) => {
                const messages = data.split("*").filter(m => m.trim().length > 0);
                const parsedOdds = messages.map((msg) => this.parseOddsMessage(msg));
                this.updateOdds(parsedOdds);
            })

            socket.on('odds:fixture', (data) => {
                const messages = data.split("*").filter(m => m.trim().length > 0);
                const parsedOdds = messages.map((msg) => this.parseOddsMessage(msg));
                this.updateOdds(parsedOdds);
            })

            socket.on('stats:live', (data) => {
                for (let sport in this.events) {
                    if (data.eid in this.events[sport]) {
                        this.events[sport][data.eid].inf = data.data
                    }
                }
            })
            socket.on('stat:live', (data) =>{
                this.updateScoreboards(data)
            })

            socket.on('fixtures', (data) => {
                const fixtures = useFixturesStore()
                try {
                    const parsed = typeof data === "string" ? JSON.parse(data) : data
                    fixtures.updateOrAddFixture(parsed)
                } catch (err) {
                    console.error("Error parsing fixture update:", err)
                }
            })
        },

        updateOdds(odds) {
            const betslip = useBetslipStore()
            const authStore = useAuthStore()
            const fixtures = useFixturesStore()
            const { selections } = storeToRefs(fixtures)
            const mrg = authStore.marketTemplate
            const { getUser } = storeToRefs(authStore)
            const p = getUser.value?.p ?? 0
            const mr = getUser.value?.mrg ?? 0

            for (let odd of odds) {
                const eventId = Number(odd.fi)
                let price = Number(odd.p)

                if (mrg[odd.mi]) {
                    price = price / (Number(mrg[odd.mi]) / 100 + 1)
                }
                if (mr && mr != "0") {
                    price = price / (mr / 100 + 1)
                }
                if (p && p != "0") {
                    price = price - (p / 100)
                }
                odd.p = price > 1 ? price : 1

                const eventSel = selections.value.find(s => Number(s.fi) == eventId)
                if (!eventSel) continue

                if (!Array.isArray(eventSel.m)) eventSel.m = []

                const marketKey = odd.mui
                let market = eventSel.m.find(mkt => mkt.key === marketKey)

                if (!market) {
                    market = { key: marketKey, i: Number(odd.mi), o: [] }
                    eventSel.m.push(market)
                }

                const index = market.o.findIndex(o => o.i === odd.i)

                if (index > -1) {
                    market.o[index] = { ...market.o[index], ...odd }
                } else {
                    market.o.push(odd)
                }

                betslip.updateOdd(eventId, odd)
            }

            fixtures.selections = [...selections.value]
        },

        updateScoreboards(newInf) {
            const fixtures = useFixturesStore()
            const { scoreboards } = storeToRefs(fixtures)

            const existing = scoreboards.value.find(sb => sb.fi === newInf.fi)

            if (existing) {
                if(newInf.data.c){
                 existing.c = newInf.data.c   
                }
                if(newInf.data.inf){
                  existing.inf = newInf.data.inf   
                }
                existing.result = newInf.data.result
                existing.state = newInf.data.state
            } 
        }

    }
})